import React, { createContext, useState, useEffect } from 'react';
import i18n from 'i18next';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [language, setLanguage] = useState(() => {
    // Try to get the user's preference from local storage
    const savedLanguage = localStorage.getItem('language');
    // Всегда возвращаем 'en' по умолчанию, если нет сохранённого языка
    return savedLanguage || 'en';
  });

  // Save language preference and initialize i18n
  useEffect(() => {
    localStorage.setItem('language', language);
    
    // Меняем язык в i18n
    i18n.changeLanguage(language).then(() => {
      // Установим таймаут в 100мс, чтобы убедиться, что i18n полностью инициализирован
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    });
  }, [language]);

  // Вместо простого переключения, теперь устанавливаем конкретный язык
  const setAppLanguage = (langCode) => {
    setLanguage(langCode);
  };

  return (
    <LanguageContext.Provider value={{ language, setAppLanguage, isLoading }}>
      {children}
    </LanguageContext.Provider>
  );
}; 